import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffectOnce } from 'hooks/useEffectOnce';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@myRedux/hooks';
import { apiConnectionFailure, getApiRootAsync, selectApiRoot } from '@myRedux/api/apiSlice';
import { selectTheme, setTheme } from '@myRedux/user/userSettingsSlice';
import { shouldMakeNetworkCall } from '@myRedux/networkState';
import Navbar from 'components/navbar/navbar';
import { Container } from '@componentLibraryWrapper/container';
import { useMediaQuery } from '@componentLibraryWrapper/useMediaQuery';
import './App.scss';

const Home = lazy(() => import('pages/home/home'));
const SchoolDistrict = lazy(() => import('pages/state/schoolDistrict/schoolDistrict'));
const Teacher = lazy(() => import('pages/state/teacher/teacher'));
const UserSettings = lazy(() => import('pages/user/settings/settings'));
const UserEmailVerification = lazy(() => import('pages/user/verifyEmail/verifyEmail'));
const GoogleCallback = lazy(() => import('pages/oauth/google/callback'));
// const ForgotPassword = lazy(() => import('pages/forgotPassword/forgotPassword'));

function App() {
  const dispatch = useAppDispatch();
  const apiRootSelector = useAppSelector(selectApiRoot);
  const selectedTheme = useAppSelector(selectTheme);

  const themeFromMediaQuery = useMediaQuery('(prefers-color-scheme: dark)') ? 'dark' : 'light';
  const theme = createTheme({
    palette: {
      mode: selectedTheme
    },
  });

  useEffectOnce(() => {
    const connectToApi = async () => {
      if (shouldMakeNetworkCall(apiRootSelector)) {
        await dispatch(getApiRootAsync());
      }
    }

    dispatch(setTheme(themeFromMediaQuery))
    try { 
      connectToApi()
    }
    catch (error) {
      dispatch(apiConnectionFailure(error));
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <Suspense fallback={<div>Loading...</div>}>
            <Navbar />
            <Container maxWidth="xl">
              <Routes>
                <Route path='/'>
                  <Route index element={<Home />} />
                  <Route path='user'>
                    <Route index element={<UserSettings />} />
                    <Route path='verifyemail/:token' element={<UserEmailVerification />}/>
                  </Route>
                  <Route path='oauth'>
                    <Route path='google'>
                      <Route path='callback'>
                        <Route index element={<GoogleCallback />} />
                      </Route>
                    </Route>
                  </Route>
                  {/* <Route path='forgotpassword'>
                    <Route index element={<ForgotPassword />}/>
                  </Route> */}
                  <Route path='state/:state/schooldistrict/:schoolDistrict'>
                    <Route index element={<SchoolDistrict />} />
                    <Route path='teacher/:teacher'>
                      <Route index element={<Teacher />} />
                    </Route>
                  </Route>
                </Route>
              </Routes>
            </Container>
          </Suspense>
        </BrowserRouter>
      </CssBaseline>
    </ThemeProvider>
  );
}

export default App;

